// extracted by mini-css-extract-plugin
export default {"menuBlock":"yG-z","title":"zG-z","nav":"AG-z","flexCell":"BG-z","facetLink":"CG-z"};